import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z"
}), 'MeetingRoomSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MeetingRoomSharp.js
// module id = 4794
// module chunks = 2